import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsoptometry',
  templateUrl: './asahsoptometry.component.html',
  styleUrls: ['./asahsoptometry.component.scss']
})
export class AsahsoptometryComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
